<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template #headAction>
        <a-button
          v-if="user.IsVirtual"
          style="margin-left:10px"
          type="primary"
          @click="$router.push({ name: 'CopyShopData' })"
          >门店数据复制</a-button
        >
        <a-button
          v-if="user.IsVirtual"
          style="margin-left:10px"
          type="primary"
          @click="onRegister"
          >注册序列号</a-button
        >
        <a-button
          v-if="user.IsVirtual"
          style="margin-left:10px"
          type="primary"
          @click="onAdminSetting"
          >管理员设置</a-button
        >
        <a-button
          v-if="user.IsVirtual"
          style="margin-left:10px"
          type="primary"
          @click="onAdminLoginLog"
          >管理员登陆日志</a-button
        >
        <a-button
          v-if="user.IsVirtual && user.Account == 'superadmin'"
          style="margin-left:10px"
          type="primary"
          @click="onAddGroupCompany"
          >新增集团</a-button
        >
        <a-button
          v-if="
            (user.CompanyCode == 'group' || user.CompanyCode == 'opugroup') &&
              user.Account == 'superadmin'
          "
          style="margin-left:10px"
          type="primary"
          @click="onViewNightCheckInfo"
          >查看自动夜审</a-button
        >
      </template>
      <template v-slot:state="slotProps">
        <a-badge v-if="slotProps" status="success" text="启用" />
        <a-badge v-else status="error" text="停用" />
      </template>
      <!-- <span slot="action">
        <a @click="onAction">注册</a>
      </span> -->
      <template v-slot:rowAction="slotProps">
        <a-button type="link" size="small" @click="edit(slotProps)"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button type="link" size="small" @click="onAction(slotProps)"
          >注册</a-button
        >
        <a-divider type="vertical" />
        <a-popconfirm
          placement="bottomRight"
          okText="确认"
          cancelText="取消"
          @confirm="del(slotProps)"
        >
          <template slot="title">
            <p>您确认删除吗？</p>
          </template>
          <a-button type="link" size="small">
            删除
          </a-button>
        </a-popconfirm>
      </template>
      <template slot="logo">
        <div style="max-width:300px">
          <a-upload
            listType="picture-card"
            :beforeUpload="beforeUpload"
            @change="avatarChange"
            :showUploadList="false"
          >
            <img v-if="ImageUrl" :src="ImageUrl" class="photo-img" />
            <div class="ant-upload-box" v-else>
              <template>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
              </template>
            </div>
          </a-upload>
        </div>
      </template>
    </data-table>
    <a-button
      type="danger"
      v-if="user.IsVirtual"
      ghost
      size="small"
      @click="onChangeNightCheckModel"
      >修改门店夜审模式</a-button
    >
    <a-button
      v-if="user.IsVirtual"
      style="margin-left:10px"
      size="small"
      @click="onCompanyToNewGroup"
      >门店转移至新的集团</a-button
    >
    <a-modal
      centered
      title="注册序列号"
      :maskClosable="visible.maskClosable"
      v-model="visible.showModal"
      @ok="handleOk"
      okText="确认"
    >
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="序列号"
          :labelCol="{ span: 8 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-textarea
            autosize
            v-decorator="[
              'SerialNumber',
              { rules: [{ required: true, message: '请输入序列号!' }] }
            ]"
            size="large"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="提示"
      v-model="visibleWarning"
      @ok="handleOkWarning"
      @cancel="handleCancelWarning"
    >
      <p>修改【编号】或【门店名称】会导致系统无法使用，是否确认？</p>
    </a-modal>
    <a-modal
      title="输入密码"
      :visible="visiblePass"
      :destroyOnClose="true"
      :maskClosable="false"
      @ok="passSubmit"
      @cancel="visiblePass = false"
    >
      <a-form :form="passForm" layout="inline">
        <a-form-item label="密码">
          <a-input
            type="password"
            style="width:200px"
            v-decorator="[
              'Pass',
              { rules: [{ required: true, message: '请输入密码' }] }
            ]"
            placeholder="请输入密码"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="输入转移到的集团Code"
      :visible="visibleTrans"
      :destroyOnClose="true"
      :maskClosable="false"
      @ok="transSubmit"
      @cancel="visibleTrans = false"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="transForm" layout="inline">
        <a-form-item label="待转移的门店">
          {{ selectRow.Name }}
        </a-form-item>
        <a-form-item label="转移到的集团Code">
          <a-input
            v-decorator="[
              'newGroupCode',
              { rules: [{ required: true, message: '请输入转移到的集团Code' }] }
            ]"
            placeholder="请输入集团Code"
          />
        </a-form-item>
        <a-form-item label="是否直接执行">
          <a-switch v-decorator="['isExecute']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <AdminLoginLogModal ref="AdminLoginLogModal"></AdminLoginLogModal>
    <SettingAdminModal ref="SettingAdminModal"></SettingAdminModal>
    <AddGroupCompany ref="AddGroupCompany" @submit="onReload"></AddGroupCompany>
    <NightCheckInfo ref="NightCheckInfo"></NightCheckInfo>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import cloneDeep from "lodash/cloneDeep";
import { cache } from "@/utils/common";
import { mapState } from "vuex";
import AdminLoginLogModal from "./components/AdminLoginLogModal";
import SettingAdminModal from "./components/SettingAdminModal";
import AddGroupCompany from "./components/AddGroupCompany";
import NightCheckInfo from "./components/NightCheckInfo";
export default {
  components: {
    DataTable,
    AdminLoginLogModal,
    SettingAdminModal,
    AddGroupCompany,
    NightCheckInfo
  },
  data() {
    return {
      versionConfig,
      form: this.$form.createForm(this),
      visible: {
        maskClosable: false,
        showModal: false
      },
      selectRow: {},
      selectRowId: "",
      CodeName: false,
      Waring: false, //是否确认或取消
      visibleWarning: false,
      editData: {},
      user: null,
      visiblePass: false,
      passForm: this.$form.createForm(this),
      ImageUrl: "",
      currentCompanyId: "",
      transForm: this.$form.createForm(this),
      visibleTrans: false,
      confirmLoading: false
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig
    })
  },
  created() {
    this.user = cache.get("user");
    const sysName = `是否是${
      this.appConfig.title ? this.appConfig.title : "智云Plus"
    }系统`;
    const content = [
      {
        label: "门店名称",
        name: "Name",
        option: {
          rules: [
            { required: true, message: "请输入门店名称!" },
            {
              validator: (rule, value, callback) => {
                if (value.length > 20) {
                  callback(new Error("名称长度最大为20位"));
                } else {
                  callback();
                }
              }
            }
          ]
        },
        props: {
          length: 20
        },
        onChange: value => {
          this.onChangeCodeName(value);
        }
      },
      {
        label: "门店编号",
        name: "Code",
        option: {
          rules: [
            { required: true, message: "请输入门店编号!" },
            {
              validator: (rule, value, callback) => {
                if (value.length < 4 || value.length > 20) {
                  callback(new Error("编号长度为4-20位"));
                } else {
                  callback();
                }
              }
            }
          ]
        },
        props: {
          length: 20
        },
        onChange: value => {
          this.onChangeCodeName(value);
        }
      },
      {
        label: "门店全称",
        name: "FullName"
      },
      {
        label: "地址",
        name: "Address"
      },
      {
        label: "联系人",
        name: "Contact"
      },
      {
        label: "联系电话",
        name: "ContactTel"
      },
      {
        label: "排序",
        name: "Sort",
        type: "number"
      },
      {
        label: "状态",
        name: "Status",
        type: "switch"
        // props:{
        //   disabled:true
        // }
      },
      {
        label: "  ",
        colon: false,
        name: "IsZYPlus",
        type: "checkbox-group",
        data: [{ label: sysName, value: 1 }]
      },
      {
        label: "门店简介",
        name: "Description",
        colnum: 2
      }
    ];
    const editContent = cloneDeep(content);
    editContent.splice(editContent.length - 1, 0, {
      label: "酒店Logo",
      name: "Img",
      slot: "logo"
    });
    this.option = {
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "门店名称",
            name: "Name"
          }
        ]
      },
      form: {
        title: "门店",
        width: 1000,
        colnum: 2,
        content: content,
        add: {
          submitApi: "Company_Add",
          onOpenAfter: () => {
            this.currentCompanyId = "";
            this.ImageUrl = "";
            return { Sort: 0 };
          },
          onSubmitBefore: values => {
            return this.onBeforeSubmit(values);
          }
        },
        edit: {
          submitApi: "Company_Edit",
          content: editContent,
          onOpenAfter: res => {
            const data = cloneDeep(res);
            data.Status = res.ValidStatus === 1 ? true : false;
            // if (this.user.IsVirtual) {
            data.IsZYPlus = res.IsZYPlus ? [1] : [];
            // }

            return data;
          },
          onSubmitBefore: values => {
            if (this.CodeName) {
              this.visibleWarning = true;
              this.editData = values;
              if (this.Warning) {
                this.Warning = false;
                this.CodeName = false;
                return this.onBeforeSubmit(values);
              } else {
                return false;
              }
            } else {
              return this.onBeforeSubmit(values);
            }
          }
        },
        del: {
          submitApi: "Company_Delete"
        }
      },
      grid: {
        api: "Company_GetPageList",
        props: {
          scroll: {
            x: 2200,
            y: window.document.body.clientHeight - 290
          }
        },
        columns: [
          {
            title: "序号",
            width: "50px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "门店编号",
            width: 80,
            dataIndex: "Code"
          },
          {
            title: "排序",
            width: 50,
            dataIndex: "Sort"
          },
          {
            title: "门店名称",
            width: 130,
            dataIndex: "Name"
          },
          {
            title: "门店全称",
            width: 130,
            dataIndex: "FullName"
          },
          {
            title: "注册码有效期",
            dataIndex: "ValidDate"
          },
          {
            title: "账务日期",
            width: 100,
            dataIndex: "AccountDate"
          },
          {
            title: "夜审模式",
            width: 100,
            dataIndex: "NightCheckModel"
          },
          {
            title: "夜审时间",
            width: 100,
            dataIndex: "NightAuditTime"
          },
          {
            title: "自动过租时间",
            width: 100,
            dataIndex: "OverRentTime"
          },
          {
            title: "是否活跃",
            width: 100,
            dataIndex: "IsAlive",
            customRender: text => {
              return text ? (
                <a-badge status="success" text="是" />
              ) : (
                <a-badge status="error" text="否" />
              );
            }
          },
          {
            title: sysName,
            width: 170,
            dataIndex: "IsZYPlus",
            customRender: text => {
              return text ? "是" : "否";
            }
          },
          {
            title: "门店简介",
            width: 200,
            dataIndex: "Description"
          },
          {
            title: "地址",
            width: 150,
            dataIndex: "Address"
          },
          {
            title: "联系人",
            width: 100,
            dataIndex: "Contact"
          },
          {
            title: "联系电话",
            dataIndex: "ContactTel",
            width: 100
          },
          {
            title: "状态",
            dataIndex: "ValidStatus",
            width: 80,
            scopedSlots: { customRender: "state" }
          },
          {
            title: "操作",
            dataIndex: "Id",
            fixed: "right",
            width: 220,
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    onRegister() {
      this.visiblePass = true;
    },
    passSubmit() {
      const row = this.$refs.dataTable.getSelected();
      this.passForm.validateFields((err, values) => {
        if (!err) {
          if (values.Pass != "1368") {
            this.$message.error("密码不正确！");
            return false;
          }
          this.visiblePass = false;
          const params = {
            name: "RegisterInVirtul"
          };
          if (row) {
            params.query = {
              Id: row.Id
            };
          }
          this.$router.push(params);
        }
      });
    },
    onBeforeSubmit(values) {
      if (values.Status === "") {
        values.Status = true;
      }
      values.Status = values.Status ? 1 : 0;
      this.visibleWarning = false;
      // if (this.user.IsVirtual) {
      if (values.IsZYPlus && values.IsZYPlus.length) {
        values.IsZYPlus = true;
      } else {
        values.IsZYPlus = false;
      }
      // }

      return values;
    },
    onAction(data) {
      this.selectRowId = data;
      this.visible.showModal = true;
      this.$nextTick(() => {
        this.form && this.form.setFieldsValue({ SerialNumber: "" });
      });
    },
    onReload() {
      this.$refs.dataTable.headSearch();
    },
    onChangeCodeName() {
      this.CodeName = true;
    },
    handleOk() {
      this.handleSubmit();
    },
    handleOkWarning() {
      this.Warning = true;
      this.$refs.dataTable.onSubmit(this.editData);
    },
    handleCancelWarning() {
      this.Warning = false;
    },
    handleSubmit() {
      const _this = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          const json = {
            UserCompanyId: this.selectRowId,
            sn: values.SerialNumber
          };
          _this.$post("Company_RSN", json).then(() => {
            this.$message.success("注册成功！");
            this.$nextTick(() => {
              this.visible.showModal = false;
              this.$refs.dataTable.headSearch();
            });
          });
        }
      });
    },
    edit(id) {
      this.currentCompanyId = id;
      this.getLogoImg();
      this.$refs.dataTable.edit(id);
    },
    del(id) {
      this.$refs.dataTable.del({ Id: id });
    },
    beforeUpload(file) {
      const readers = new FileReader();
      readers.readAsDataURL(file);
      readers.onload = e => {
        file.thumbUrl = e.target.result;
      };
      return false;
    },
    avatarChange(info) {
      const formData = new FormData();
      formData.append("companyId", this.currentCompanyId);
      formData.append("file", info.file);
      this.$post("Company_UpdateLogo", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(() => {
        this.getLogoImg();
      });
    },
    getLogoImg() {
      if (this.currentCompanyId) {
        this.$post("Company_GetLogo", { id: this.currentCompanyId }, {}).then(
          res => {
            this.ImageUrl = res.Data
              ? "data:image/jpeg;base64," + res.Data
              : "";
          }
        );
      }
    },
    onChangeNightCheckModel() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      const that = this;
      this.$confirm({
        title: "确定修改门店夜审模式吗?",
        onOk() {
          that.$post("ChangeNightCheckModel", { Id: row.Id }).then(() => {
            that.$message.success("修改成功");
            const page = that.$refs.dataTable.$refs.dataGrid.getPaginationOption();
            that.$refs.dataTable.reload(page);
          });
        }
      });
    },
    onCompanyToNewGroup() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择待转移的门店！");
        return false;
      }
      this.selectRow = row;
      this.visibleTrans = true;
    },
    copyTextToClipboard(text) {
      const element = document.createElement("textarea");
      element.value = text;
      element.setAttribute("readonly", "");
      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.fontSize = "12pt";
      const selection = document.getSelection();
      let originalRange;
      if (selection && selection.rangeCount > 0) {
        originalRange = selection.getRangeAt(0);
      }
      document.body.append(element);
      element.select();
      element.selectionStart = 0;
      element.selectionEnd = text.length;
      let isSuccess = false;
      try {
        document.execCommand("copy");
        isSuccess = true;
      } catch (e) {
        throw new Error();
      }
      element.remove();
      if (originalRange && selection) {
        selection.removeAllRanges();
        selection.addRange(originalRange);
      }
      return isSuccess;
    },
    transSubmit() {
      const that = this;
      const { selectRow } = this;
      this.transForm.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          that
            .$post("CompanyToNewGroup", {
              sourceCompanyCode: selectRow.Code,
              newGroupCode: values.newGroupCode,
              isExecute: values.isExecute
            })
            .then(res => {
              that.$message.success("操作成功");
              that.confirmLoading = false;
              const page = that.$refs.dataTable.$refs.dataGrid.getPaginationOption();
              that.$refs.dataTable.reload(page);
              if (res.Data && !values.isExecute) {
                const arr = res.Data.split("\r\n").map(v => <p>{v}</p>);
                that.$confirm({
                  title: "信息",
                  width: 800,
                  closable: true,
                  content: () => (
                    <div style="height:calc(70vh);overflowY:auto">{arr}</div>
                  ),
                  okText: "复制",
                  onOk() {
                    that.visibleTrans = false;
                    var is = that.copyTextToClipboard(res.Data);
                    if (is) {
                      that.$message.success("复制成功");
                    }
                  },
                  onCancel() {
                    that.visibleTrans = false;
                  }
                });
              } else {
                that.visibleTrans = false;
              }
            })
            .catch(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    onAdminSetting() {
      this.$refs.SettingAdminModal.onShow();
    },
    onAdminLoginLog() {
      this.$refs.AdminLoginLogModal.onShow();
    },
    onAddGroupCompany() {
      this.$refs.AddGroupCompany.onShow();
    },
    onViewNightCheckInfo() {
      this.$refs.NightCheckInfo.onShow();
    }
  }
};
</script>

<style lang="less" scoped>
.photo-img {
  display: block;
  width: 100%;
}
</style>
